import * as React from 'react';
import { InputTextFieldGroup } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Block, BlockContent, BlockHeading } from '@gandi/ui';
import { DisabledContext } from '../../formUtils/DisabledContext';
import Organization from './components/Organization';
import OrganizationSelect from './components/OrganizationSelect';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NameEditor({
  organizationEditable = false,
  inputNameProps = {},
  ...blockProps
}) {
  const {
    __
  } = useTranslator();
  const {
    disabled
  } = React.useContext(DisabledContext);
  return /*#__PURE__*/_jsxs(Block, {
    ...blockProps,
    children: [/*#__PURE__*/_jsx(BlockHeading, {
      children: __('Name & Organization')
    }), /*#__PURE__*/_jsxs(BlockContent, {
      children: [/*#__PURE__*/_jsx(InputTextFieldGroup, {
        disabled: disabled,
        required: true,
        name: "name",
        label: __("Choose your configuration's name"),
        help: __('You should name your configuration according to domain type, section type or process.'),
        ...inputNameProps
      }), organizationEditable ? /*#__PURE__*/_jsx(OrganizationSelect, {}) : /*#__PURE__*/_jsx(Organization, {})]
    })]
  });
}
NameEditor.preFetch = args => {
  const {
    organizationEditable,
    orgId,
    ...prefetchArgs
  } = args;
  if (organizationEditable === true) {
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    return OrganizationSelect.preFetch(prefetchArgs);
  }

  // eventually fetch organization if known
  return Organization.preFetch({
    orgId,
    ...prefetchArgs
  });
};
export default NameEditor;